import { useEffect, useState } from 'react';
import Axios from '../../config/axios';

let cachedLocal = null;
let pendingRequest = null;

function fetchLocal() {
    if (cachedLocal !== null) {
        return Promise.resolve(cachedLocal);
    }

    if (!pendingRequest) {
        pendingRequest = Axios.get(`/api/GetLocal`).then(response => {
            cachedLocal = response.data;
            return cachedLocal;
        });
    }

    return pendingRequest;
}

export function useLocal() {
    const [local, setLocal] = useState(cachedLocal || '');

    useEffect(() => {
        fetchLocal().then(setLocal);
    }, []);

    return local;
}

export default function getLocal() {
    return fetchLocal();
}
